import React from 'react'
import Resources from '../../../../data/services/resources'
import {fieldsToHtml, includeFields} from "../../../../util/util";
import {DEFAULT_METADATA_SELECT_SEARCH_QUERY} from "../../../../util/util-constants";
import CardSubTitle from "../../../../common/components/card/card-sub-title";
import Card from "../../../../common/components/card";
import InfoParagraph from "../../../../common/components/info-paragraph";

const BillingSection = ({fields, translate, handleInputChange}) => {
    /** Constants
     ================================================================= */
    const infoMessage = <p>Changing values will override defaults from <a href="/dispatch-settings" target="_blank"
                                                                          className="text-sky-600 hover:underline"> global
        settings</a>.</p>

    const selects = {
        ApprovedByID: {
            api: 'api/' + Resources.ContactsQuick,
            query: DEFAULT_METADATA_SELECT_SEARCH_QUERY(),
            searchMap: (it) => ({
                label: `${it.FirstName} ${it.LastName} - ${it.Email}`,
                value: it.ContactID
            })
        }
    }

    /** Render
     ================================================================= */
    const profitMarginFieldsHtml = fieldsToHtml(Object.values(Object.assign({}, includeFields(fields, ['MinimumMargin', 'AllowMarginOverride']))), translate, handleInputChange, selects)
    const bondsFieldsHtml = fieldsToHtml(Object.values(Object.assign({}, includeFields(fields, ['Bond', 'Expires', 'Number', 'Bank']))), translate, handleInputChange, selects)
    const documentsFieldsHtml = fieldsToHtml(Object.values(Object.assign({}, includeFields(fields, ['IsSendBackupDocumentsWithInvoice', 'IsDocumentsOverridden', 'DocsSettings']))), translate, handleInputChange, selects)

    return (
        <>
            <div className="grid grid-cols-2 gap-3">
                {/* Profit Margin
                        =================================================== */}
                <Card>
                    <CardSubTitle
                        className={'mb-5'}
                        subtitle={translate('text.ProfitMargin')}
                    />
                    <div className="grid grid-cols-1 gap-3">
                        {profitMarginFieldsHtml}
                    </div>

                    <InfoParagraph
                        className="my-3"
                        message={infoMessage}
                    />
                </Card>
                {/* Bonds
                        =================================================== */}
                <Card>
                    <CardSubTitle
                        className={'mb-5'}
                        subtitle={translate('text.Bonds')}
                    />
                    <div className="grid grid-cols-1 gap-3">
                        {bondsFieldsHtml}
                    </div>

                </Card>

                {/* Documents
                        =================================================== */}
                <Card>
                    <CardSubTitle
                        subtitle={translate('text.Documents')}
                    />
                    <div className="grid grid-cols-1 gap-3">
                        {documentsFieldsHtml}
                    </div>
                </Card>
            </div>
        </>
    )
}

export default BillingSection
